import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3VerticalTight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="dot-grid-1x3-vertical-tight, menu, drag, grab" maskId="round-filled-radius-1-stroke-1.5-IconDotGrid1x3VerticalTight"><rect x="10" y="3" width="4" height="4" rx="1.75" fill="currentColor"/><rect x="10" y="10" width="4" height="4" rx="1.75" fill="currentColor"/><rect x="10" y="17" width="4" height="4" rx="1.75" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3VerticalTight;
